import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/Best-Selling-Products/components/BestSellingProducts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogSlider"] */ "/vercel/path0/src/features/blog/regular-articles/components/BlogSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/Featured_categories/components/FeaturedCategories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/home/banner/components/Banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/home/Flash_sales/components/FlashSales.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/home/SaleBanner/components/SaleBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/home/Skin-Care-With-AI/components/SkinCareWithAI.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/kirei-tube/components/KireiTube.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/product_listing/components/ProductListing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromoBannerSlider"] */ "/vercel/path0/src/features/promo-banner/PromoBannerSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/Recommended-For-You/components/RecommendedForYou.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/shop-by-concern/components/ShopByConcern.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/testimonial/Testimonial.tsx");
